import emptyReducer from './emptyReducer';

const toSex = emptyReducer<string | null>(null).with({
  OneOf: (value, options, option) => (option ? option?.label : null),
});

export default toSex;
